export default __webpack_public_path__ + "static/media/high_level_logo.d7636215.png";